export function toggleSimulatorCertificateField(form) {
  if (!form) return;
  const field = form.querySelector('[name="simulator-certificate-start-date"]');
  if (!field) return;

  const productField = form.querySelector('[name="simulator-product"]');
  const formGroup = field.closest('.form-group');
  const helpEl = formGroup ? formGroup.querySelector('.field-help') : null;
  const labelEl = field.id ? form.querySelector(`label[for="${field.id}"]`) : null;
  const biogazHelpText = field.dataset.biogazChHelpText || '';

  if (helpEl && !helpEl.dataset.originalText) {
    helpEl.dataset.originalText = helpEl.textContent.trim();
  }
  if (!('originalRequired' in field.dataset)) {
    field.dataset.originalRequired = String(field.required);
  }

  const isBiogazCH = productField?.value === 'BiogazCH';

  if (isBiogazCH) {
    field.value = '';
    field.required = false;
    field.setAttribute('hidden', true);
    if (labelEl) labelEl.setAttribute('hidden', true);
    if (helpEl) helpEl.textContent = biogazHelpText;
  } else {
    field.removeAttribute('hidden');
    field.required = field.dataset.originalRequired === 'true';
    if (labelEl) labelEl.removeAttribute('hidden');
    if (helpEl && helpEl.dataset.originalText) {
      helpEl.textContent = helpEl.dataset.originalText;
    }
  }
}

document
  .querySelectorAll('.simulator-order-form')
  .forEach(toggleSimulatorCertificateField);
